import { useSession } from "next-auth/react";
import useSWRInfinite from "swr/infinite";
import { fetcher } from "utils/clientAPIs/fetcher";
import * as Sentry from "@sentry/nextjs";

const PAGE_SIZE = 10;

export const useResearchInfiniteList = ({ ticker }: { ticker: string }) => {
  const { data: session }: any = useSession();

  const getKey = (pageIndex: number, previousPageData: any) => {
    // 더 이상 데이터가 없다면 멈춤
    if (previousPageData && previousPageData?.data?.length < PAGE_SIZE)
      return null;

    // 첫 페이지라면 기준값 없이 호출
    if (pageIndex === 0) {
      return `/api/detail/report?ticker=${ticker}`;
    }

    // 다음 페이지 요청 조건
    const lastItem =
      previousPageData?.data?.[previousPageData?.data?.length - 1];
    if (!lastItem) return null;
    const lastAgendaId = lastItem?.id;
    const lastAgendaAt = lastItem?.created_at;
    return `/api/detail/report?ticker=${ticker}&lastAgendaId=${lastAgendaId}&lastAgendaAt=${lastAgendaAt}`;
  };

  const { data, setSize, size, isValidating, mutate } = useSWRInfinite(
    getKey,
    fetcher,
    {
      revalidateOnFocus: false,
      onError: (error, key) => {},
    }
  );

  const allResearch = data?.map((d) => d.data).flat() || [];
  const isLoadingInit = !data && isValidating;
  const isLoadingMore =
    isValidating && data && typeof data[size - 1] === "undefined";
  const isReachingEnd = data && data[data.length - 1]?.data?.length < PAGE_SIZE;

  return {
    researchList: allResearch,
    isLoadingInit,
    isLoadingMore,
    isReachingEnd,
    loadMore: () => setSize(size + 1),
    mutate,
  };
};
